import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer, ReferenceLine, Tooltip, Label } from 'recharts'
import { useProjectedGraphDataContext } from '../contexts/amazonPageSpeedViewsProjectedDataContext';

const AmazonProjectedViewGraph = ({}) => { 
  
  const ONE_DAY_PERCENTAGE_REQUIREMENT = 10
  const TWO_DAY_PERCENTAGE_REQUIREMENT = 45
  const ONE_DAY_LABEL = '<= 1 Day Requirement (10%)'
  const TWO_DAY_LABEL = '<= 2 Days Requirement (45%)'
  const {projectedGraphData} = useProjectedGraphDataContext()

  return (
    <div className="p-4 shadow-sm bg-white rounded">
      <h4 className="mb-0 fw-semibold">Page Views</h4>
      <div style={{ width: '100%', minHeight: 400 }}>
        <ResponsiveContainer width="100%" height={455}>
          <LineChart
            data={projectedGraphData}
            margin={{ top: 30, right: 40, left: 10, bottom: 10 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis
              domain={[0, 80]}
              tickFormatter={(tick) => `${tick.toFixed(2)}%`}
            />
            <Tooltip
              formatter={(value: number) => `${value.toFixed(2)}%`}
            />
            <Legend verticalAlign="top" height={36} />

            {/* Reference Line for 45% */}
            <ReferenceLine
              y={TWO_DAY_PERCENTAGE_REQUIREMENT}
              stroke="red"
              strokeDasharray="3 3"
            >
              <Label
                position="insideTopRight"
                value="<= 2 days requirement (45%)"
                fill="red"
                fontSize={12}
              />
            </ReferenceLine>

            {/* Reference Line for 10% */}
            <ReferenceLine
              y={ONE_DAY_PERCENTAGE_REQUIREMENT}
              stroke="green"
              strokeDasharray="3 3"
            >
              <Label
                position="insideTopRight"
                value="<= 1 day requirement (10%)"
                fill="green"
                fontSize={12}
              />
            </ReferenceLine>

            <Line
              type="monotone"
              dataKey="lessThan2DaysPercent"
              stroke="red"
              name="<= 2 days"
              strokeWidth={2}
              dot={{ r: 2 }}
            />
            <Line
              type="monotone"
              dataKey="lessThan1DayPercent"
              stroke="green"
              name="<= 1 day"
              strokeWidth={2}
              dot={{ r: 2 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};


export default AmazonProjectedViewGraph;